export default __webpack_public_path__ + "static/media/no-data.d4de76cf.png";